import { useQueryStates, parseAsInteger } from 'nuqs'

export const useAssessmentsQueueFiltersQueryState = () => {
  return useQueryStates(
    {
      companyId: parseAsInteger,
      positionId: parseAsInteger,
      shiftId: parseAsInteger,
    },
    {
      urlKeys: {
        companyId: 'company-id',
        positionId: 'position-id',
        shiftId: 'shift-id',
      },
    }
  )
}
